import fitty from 'fitty';

let fitties = fitty('.fit', { observeMutations: false });

const fitText = () => {
	if (fitties.length) {
		fitties.forEach((thisFitty) => {
			thisFitty.unsubscribe();
		});

		fitties = fitty('.fit', { observeMutations: false });
	}
};

export default fitText;
